import React from "react";
import { getYear } from "date-fns";
import { useTranslation } from "i18n";
import FooterMiniLink from "./components/FooterMiniLink";

const FooterMini = () => {
  const { t } = useTranslation();
  const currentYear = getYear(new Date());

  return (
    <footer className="mt-auto bg-white">
      <div className="page-container">
        <div className="text-grey-shark-5 flex justify-end gap-4 px-[100px] py-5 text-xs">
          {t("common:nav.footer.copyright", { year: currentYear })}
          <FooterMiniLink to="https://www.spotlight.com/help-and-faqs/">
            {t("common:nav.help")}
          </FooterMiniLink>
          <FooterMiniLink to="https://www.spotlight.com/the-small-print/privacy-policy/">
            {t("common:nav.links.privacyPolicy")}
          </FooterMiniLink>
          <FooterMiniLink to="https://www.spotlight.com/the-small-print/terms-conditions/">
            {t("common:nav.links.termsConditions")}
          </FooterMiniLink>
        </div>
      </div>
    </footer>
  );
};

export default FooterMini;
